/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TournamentTeamResponse } from './TournamentTeamResponse';
import {
    TournamentTeamResponseFromJSON,
    TournamentTeamResponseFromJSONTyped,
    TournamentTeamResponseToJSON,
    TournamentTeamResponseToJSONTyped,
} from './TournamentTeamResponse';

/**
 * Result of joining a team via invite link
 * @export
 * @interface TeamJoinResponse
 */
export interface TeamJoinResponse {
    /**
     * 
     * @type {boolean}
     * @memberof TeamJoinResponse
     */
    success: boolean;
    /**
     * 
     * @type {TournamentTeamResponse}
     * @memberof TeamJoinResponse
     */
    team: TournamentTeamResponse;
    /**
     * 
     * @type {string}
     * @memberof TeamJoinResponse
     */
    message: string;
}

/**
 * Check if a given object implements the TeamJoinResponse interface.
 */
export function instanceOfTeamJoinResponse(value: object): value is TeamJoinResponse {
    if (!('success' in value) || value['success'] === undefined) return false;
    if (!('team' in value) || value['team'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function TeamJoinResponseFromJSON(json: any): TeamJoinResponse {
    return TeamJoinResponseFromJSONTyped(json, false);
}

export function TeamJoinResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TeamJoinResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'],
        'team': TournamentTeamResponseFromJSON(json['team']),
        'message': json['message'],
    };
}

export function TeamJoinResponseToJSON(json: any): TeamJoinResponse {
    return TeamJoinResponseToJSONTyped(json, false);
}

export function TeamJoinResponseToJSONTyped(value?: TeamJoinResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'team': TournamentTeamResponseToJSON(value['team']),
        'message': value['message'],
    };
}

